import { cyrillic, invalidSymbols } from '~/util/validators/vuelidateValidators.js'

export function phoneValidationErrorMessage(e) {
  const arr = []
  if (!e.required) {
    arr.push(this.$t('popup.errors.required'))
  }
  else if (!e.minLength || !e.custom) {
    arr.push(this.$t('inputs.wrongPhoneNumber'))
  }
  return arr
}

export function emailValidationErrorMessage(e) {
  const arr = []
  if (!e.required) {
    arr.push(this.$t('popup.errors.required'))
  }
  else if (!e.email) {
    arr.push(this.$t('popup.errors.email'))
  }
  else if (!e.notOnlyNumbersInDomain) {
    arr.push(this.$t('popup.errors.email'))
  }
  else if (!e.notStopDomain) {
    arr.push(this.$t('popup.errors.email'))
  }
  return arr
}

export function passwordValidationErrorMessage(e) {
  const arr = []
  if (!e.required) {
    arr.push(this.$t('popup.errors.required'))
  }
  else if (e.hasOwnProperty('cyrillic') && !e.cyrillic) {
    arr.push(this.$t('forms.password.cyrillic'))
  }
  else if (e.hasOwnProperty('invalidSymbols') && !e.invalidSymbols) {
    arr.push(this.$t('forms.password.symbols'))
  }
  else if (!e.minLength) {
    arr.push(this.$t('popup.errors.minLength'))
  }
  return arr
}

export function password2ValidationErrorMessage(e) {
  const arr = []
  if (!e.sameAs) {
    arr.push(this.$t('forms.errors.passwordChange.password2'))
  }
  return arr
}
